import _ from 'lodash';
import { parseFetchAllRequest as parseAllRequest } from 'containers/App/modules/entities/users/users.parsers';

// Convert generic grid payload into SearchRequestV2-compatible body
export const parseFetchAllRequest = (payload) => {
	const base = parseAllRequest(payload) || {};
	const { filter: filterArray, sort, limit, page, search } = base;

	// users.parsers returns filter as array of { prop, values }
	// processing expects map:
	//  - single value -> { [prop]: { eq: value } }
	//  - multiple values -> { [prop]: { in: [values...] } }
	//  - time range filters -> { [prop]After: { from: "..." }, [prop]Before: { to: "..." } }
	const filter = {};
	
	(filterArray || []).forEach((f) => {
		if (!f || !f.prop) return;
		const values = Array.isArray(f.values) ? f.values : (f.values != null ? [f.values] : []);
		if (values.length === 0) return;
		
		// Handle time range filters (ending with "After" or "Before")
		if (f.prop.endsWith('After')) {
			filter[f.prop] = { from: values[0] };
		} else if (f.prop.endsWith('Before')) {
			filter[f.prop] = { to: values[0] };
		} else {
			// Regular filters
			if (values.length === 1) {
				filter[f.prop] = { eq: values[0] };
			} else {
				filter[f.prop] = { in: values };
			}
		}
	});

	const sortList = (sort || []).map((s) => ({
		prop: s.prop || s.key || s.field,
		order: (s.order || 'ASC').toUpperCase(),
	}));

	return {
		filter,
		freeTextSearch: search,
		sort: sortList,
		limit,
		page,
	};
};

export const parseFetchAllSuccess = (responseData) => {
	// response: { metadata, data: [...] }
	return responseData.data;
};


